import React from 'react'
import { View } from 'react-native'
import { Dialog, DialogActions, DialogContent, IconButton } from '@mui/material'
import { Close } from '@mui/icons-material'

import { Button } from '../button'
import { Text } from '../text'
import CheckCircle from '../../assets/icons/check-circle.svg'
import { color, spacing } from '../../theme'

export interface ReportSubmittedDialogProps {
  open: boolean
  onSubmit: () => void
  onClose: () => void
}

export function ReportSubmittedDialog(props: ReportSubmittedDialogProps) {
  const { open, onSubmit, onClose } = props
  const handleConfirm = () => {
    onSubmit()
    handleClose()
  }

  const handleClose = () => {
    onClose()
  }

  return (
    <Dialog aria-labelledby="confirmation-dialog-title" open={open}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
          paddingLeft: 20,
          paddingTop: 10,
          paddingBottom: 10,
          minWidth: 350,
        }}
      >
        <Text
          variant="labelEmphasized"
          text="Report Submitted"
          style={{
            marginTop: '15px',
          }}
        />
        <IconButton
          onClick={(e) => {
            e.stopPropagation()
            handleClose()
          }}
          size="large"
        >
          <Close htmlColor={color.shade50} style={{ fontSize: 22 }} />
        </IconButton>
      </div>
      <DialogContent style={{ paddingBottom: 40 }}>
        <View
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            paddingVertical: spacing[2],
            marginBottom: spacing[4],
          }}
        >
          <View style={{ marginBottom: '10px' }}>
            <CheckCircle />
          </View>
          <View style={{ display: 'flex', flexDirection: 'column', marginLeft: spacing[3] }}>
            <Text variant="label" tx="Discuss.reportThanks" style={{ textAlign: 'center' }} />
            <Text
              variant="body1"
              style={{ color: color.shade50, textAlign: 'center' }}
              tx="Discuss.reportSafe"
            />
          </View>
        </View>
      </DialogContent>
      <DialogActions
        style={{ paddingTop: 0, paddingRight: 20, paddingBottom: 20, paddingLeft: 20 }}
      >
        <Button
          onClick={(e) => {
            e.stopPropagation()
            handleConfirm()
          }}
          text="OK"
          fullWidth
          sx={{ marginLeft: '20px', marginRight: '20px', marginBottom: '20px' }}
        />
      </DialogActions>
    </Dialog>
  )
}
